export default "__VITE_ASSET__QcuJ1vR6__"